<style>
    /* --- Base para todos los Badges de Estado --- */
    .badge-status {
        /* Asegura que el contenedor sea flex para centrar contenido */
        display: inline-flex; 
        align-items: center; /* Centrado vertical */
        justify-content: center; /* Centrado horizontal */
        width: 32px; /* Ligeramente más grande para mejor visibilidad del ícono */
        height: 32px;
        border-radius: 50%; /* Asegura que sea un círculo perfecto */
        overflow: hidden; /* Corta cualquier contenido que se desborde */
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); 
        transition: all 0.3s ease-in-out; 
        cursor: pointer; 
    }

    /* --- Estilos para los Íconos (dentro del Badge) --- */
    .badge-status i {
        font-size: 16px; /* Tamaño del ícono, ajusta según necesidad */
        color: #FFFFFF; /* Color blanco para el ícono para alto contraste */
        /* Ligera sombra de texto para que el ícono resalte (opcional) */
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2); 
    }

    /* --- Colores Específicos para cada Estado (adapta a tus colores de tema) --- */

    /* Estado 'Aprobado' (Success) */
    .badge-success {
        background-color: #28a745; /* Bootstrap Green */
        /* Puedes añadir un gradiente para un efecto más "pro" */
        background-image: linear-gradient(135deg, #28a745 0%, #218838 100%);
        border: 1px solid #218838; /* Borde sutil para definirlo */
    }

    /* Estado 'Detenido/Rechazado' (Danger) */
    .badge-danger {
        background-color: #dc3545; /* Bootstrap Red */
        background-image: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
        border: 1px solid #c82333;
    }

    /* Estado 'Advertencia/Pendiente' (Warning) */
    .badge-warning {
        background-color: #ffc107; /* Bootstrap Yellow */
        background-image: linear-gradient(135deg, #ffc107 0%, #e0a800 100%);
        border: 1px solid #e0a800;
    }

    /* Estado 'Neutro/Desconocido' (Secondary) */
    .badge-secondary {
        background-color: #6c757d; /* Bootstrap Grey */
        background-image: linear-gradient(135deg, #6c757d 0%, #5a6268 100%);
        border: 1px solid #5a6268;
    }

    .professional-badge {
        display: inline-flex; /* Permite centrar contenido y control de tamaño */
        align-items: center;  /* Centrado vertical del texto */
        justify-content: center; /* Centrado horizontal del texto */
        
        padding: 0.4em 0.8em; /* Relleno superior/inferior y lateral */
        border-radius: 0.35rem; /* Bordes ligeramente redondeados (puedes usar 50% para píldora) */
        font-size: 0.85em; /* Tamaño de fuente ligeramente más pequeño */
        font-weight: 600; /* Texto más audaz */
        text-transform: uppercase; /* Texto en mayúsculas para un aspecto más limpio */
        letter-spacing: 0.05em; /* Espaciado entre letras para mejor legibilidad */
        white-space: nowrap; /* Evita que el texto se rompa en varias líneas */
        
        color: #FFFFFF; /* Color de texto blanco por defecto para alto contraste */
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15); /* Sombra suave para profundidad */
        transition: all 0.2s ease-out; /* Transiciones suaves para cambios de estado */
        cursor: pointer; 
    }

    /* Badge para 'Active' (Verde - Success) */
    .professional-badge-success-badge {
        background-color: #28a745; /* Color base Bootstrap Green */
        background-image: linear-gradient(45deg, #28a745 0%, #218838 100%); /* Gradiente sutil */
        border: 1px solid #218838; /* Borde que coincide con el color del gradiente */
    }

    .professional-badge-warning-badge {
       background-color: #ffc107 !important;
    background-image: linear-gradient(135deg, #ffc107 0%, #e0a800 100%) !important;
    border: 1px solid #e0a800 !important;
    }

    /* Badge para 'Cancelled' (Rojo - Danger) */
    .professional-badge-danger-badge {
        background-color: #dc3545; /* Color base Bootstrap Red */
        background-image: linear-gradient(45deg, #dc3545 0%, #c82333 100%); /* Gradiente sutil */
        border: 1px solid #c82333;
    }

    /* Badge por defecto/información (Azul/Gris - Info/Secondary) */
    .professional-badge-info-badge {
        background-color: #17a2b8; /* Color base Bootstrap Info (azul) */
        background-image: linear-gradient(45deg, #17a2b8 0%, #138496 100%); /* Gradiente sutil */
        border: 1px solid #138496;
        /* Si prefieres un gris neutro para 'info', puedes usar: */
    }

    /* Opcional: Estilos al pasar el ratón (hover) para interactividad */
    .professional-badge:hover {
        transform: translateY(-1px); /* Ligero levantamiento */
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Sombra más pronunciada */
    }
</style>
<template>
    <div>
        <div class="content-wrapper">
            <div class="row">
                <div class="col-sm-12 col-md-6">
                    <app-breadcrumb :page-title="$t('costs')" :directory="$t('list')" :icon="'grid'" />
                </div>
                <div class="col-sm-12 col-md-6 breadcrumb-side-button">
                    <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                        <button
                            type="button" class="btn btn-success btn-with-shadow"
                            :disabled="selectedRows.length === 0"
                            @click="sendToContracts"
                        >
                            {{ $t('send_contract') }} ({{ selectedRows.length }})
                        </button>
                        <button 
                            @click="openModalAddOcean"
                            type="button" class="btn btn-primary btn-with-shadow">
                            {{ $t('add_ocean_cost') }}
                        </button>
                        <button 
                            @click="openModalAddTrucking"
                            type="button" class="btn btn-primary btn-with-shadow">
                            {{ $t('add_truck_cost') }}
                        </button>
                    </div>
                </div>
            </div>
            <app-table :id="tableId" :options="options" @action="getListAction" :selected-url="selectedUrl" @getRows="onRowsSelected" />
        </div>

        <AddCosting 
            :key="modalKey"
            type="ocean"
            :cost_id="this.cost_id"
            :is_view="this.is_view"
            :is_edit="this.is_edit"
            :is_revision="this.is_revision"
            :is_duplicated="this.is_duplicated"
            v-if="addOceanCost"
            @close="addOceanCost = false"
            @save="handleSave"
            @save_revision = "handleSaveRevision" 
            @update="handelUpdate"/>

        <AddCosting
            :key="modalKey"
            type="truck" 
            :cost_id="this.cost_id" 
            :is_view="this.is_view"
            :is_edit="this.is_edit"
            :is_revision="this.is_revision"
            :is_duplicated="this.is_duplicated"
            v-if="addTruckingCost"
            @close="addTruckingCost = false"
            @save="handleSave" 
            @save_revision = "handleSaveRevision"
            @update="handelUpdate"/>       
 
        <app-delete-modal 
            v-if="deleteConfirmationModalActive" 
            :preloader="deleteLoader" 
            modal-id="demo-delete"
            @confirmed="confirmed" 
            @cancelled="cancelled" />

    </div>
</template>

<script>
import configTable from "./mixins/configTable.js";
import { FormMixin } from '../../../../core/mixins/form/FormMixin.js';
import CoreLibrary from "../../../../core/helpers/CoreLibrary.js";
import { CONTRACTS_ADD } from "../../../Config/ApiUrl.js";
import { urlGenerator } from "../../../Helpers/AxiosHelper.js";
import { table } from './mixins/table.js';
import AddCosting from "./AddCosting.vue";
import { update_data, delete_cost, validateCostBeforeConvert, get_data_customTable } from "./api/api.js";
import {clearStorage, setStorage} from './mixins/functions.js';

export default {
    extends: CoreLibrary,
    mixins: [table, FormMixin],
    components :{
        AddCosting
    },  
    data() {
        return {
            modalKey: 0,
            is_view : false,
            is_edit : false,
            is_revision: false,
            is_duplicated : false,
            cost_id : null,
            tableId: 'advance-table',
            options: configTable,
            addOceanCost : false,
            addTruckingCost : false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            rowData: {},
            selectedRows: [],
        }
    },
    
    created() {
        this.options.columns = this.tableColumns;
    },

    methods : {
        onRowsSelected(selectedRows, bulkSelect) {
            this.selectedRows = selectedRows;
        },

        async sendToContracts() {
            //  Validar no estar enviando costos repetidos las revisiones
            const conflictoOrigin = this.selectedRows.find(row =>
                row.origin && this.selectedRows.some(r => r.cost_number === row.origin)
            );
            if (conflictoOrigin) {
                this.$toastr.w(`Cost number ${conflictoOrigin.cost_number} cannot be selected together with its origin ${conflictoOrigin.origin}.`);
                return;
            }

            const origenesConValor = this.selectedRows.filter(row => row.origin); // descarta null, undefined, '' 
            const origenesDuplicados = origenesConValor.filter((row, index) =>
                origenesConValor.findIndex(r => r.origin === row.origin) !== index
            );
            if (origenesDuplicados.length > 0) {
                const origenRepetido = origenesDuplicados[0].origin;
                this.$toastr.w(`Origin "${origenRepetido}" is repeated in the selected rows.`);
                return;
            }

            //  Validar que la fila seleccionada no este en estado contratado
            const yaContratado = this.selectedRows.find(row => row.cost_status === 'contrated');
            if (yaContratado) {
                this.$toastr.w(`Cost number ${yaContratado.cost_number} is already under contract.`);
                return; 
            }

            // Validar que el costo en otras versiones no este contratado 
            const ids = this.selectedRows.map(row => row.id);
            const response = await validateCostBeforeConvert(ids, this.$toastr);

            if (!response) {
                this.selectedRows = [];  
                this.$hub.$emit('reload-' + this.tableId);
                return;           
            }


            const supplierIds = [...new Set(this.selectedRows.map(row => row.supplier_id))];
            if (supplierIds.length > 1) {
                this.$toastr.w(`You cannot select rows with different suppliers.`);
                return;
            }

            const customerIds = [...new Set(this.selectedRows.map(row => row.customer_id))];
            if (customerIds.length > 1) {
                this.$toastr.w(`You cannot select rows with different customers.`);
                return;
            }

            // Un unico país
            const countryIds = [...new Set(this.selectedRows.map(row => row.country_id))];
            if (countryIds.length > 1) {
                this.$toastr.w(`You cannot select rows with different country.`);
                return;
            }

            if (this.selectedRows.length >= 4) {
                this.$toastr.w(`You cannot convert more than 4 costs.`);
                return;
            }


            // En este punto ya pasaron las validaciones, utilizar el route, y setear el storage
            clearStorage();
            await setStorage(this.selectedRows, get_data_customTable);
            setTimeout(() => {
                window.location.replace(urlGenerator(CONTRACTS_ADD));
            }, 2000);
        },
       
        getListAction(rowData, actionObj, active) {
            const base_url = localStorage.getItem("base_url");
            this.rowData = rowData;
            if (actionObj.title === 'Delete') {
                const status = rowData.cost_status;
                if (status !== 'pending') {
                    this.$toastr.w('You cannot remove completed costs');
                }else{
                    this.openDeleteModal();
                }    
            }
            else if (actionObj.title == 'View') {
                const rowId = rowData.id; // id de la tabla costing
                this.cost_id = rowId;
                this.is_view = true;
                this.is_edit = false;
                this.is_revision = false;
                this.is_duplicated = false;
                if (rowData.cost_type === 'ocean') {
                    this.addOceanCost = true;
                }else if(rowData.cost_type === 'truck'){
                    this.addTruckingCost = true;
                }
            }
            else if (actionObj.title === 'Edit') {
                const reference = rowData.cost_number;
                if (reference.startsWith('CO-')) {
                    const {has_revision} = rowData;
                    if (has_revision === '1') {
                        this.$toastr.e("This costing sheet cannot be edited because it already has an associated revision.");
                        return;
                    }
                    const rowId = rowData.id; // id de la tabla costing
                    this.cost_id = rowId;
                    this.is_view = false;
                    this.is_edit = true;
                    this.is_revision = false;
                    this.is_duplicated = false;
                    if (rowData.cost_type === 'ocean') {
                        this.addOceanCost = true;
                    }else if(rowData.cost_type === 'truck'){
                        this.addTruckingCost = true;
                    }
                }else{
                    this.$toastr.e("You can't edit a revision from an existing revision. Please use the original record instead.");
                    return;
                }
            }
            else if (actionObj.title === 'Revision') {
                const reference = rowData.cost_number;
                if (reference.startsWith('CO-')) {
                    const rowId = rowData.id; // id de la tabla costing
                    this.cost_id = rowId;
                    this.is_view = false;
                    this.is_edit = false;
                    this.is_revision = true;
                    this.is_duplicated = false;
                    if (rowData.cost_type === 'ocean') {
                        this.addOceanCost = true;
                    }else if(rowData.cost_type === 'truck'){
                        this.addTruckingCost = true;
                    }
                }else{
                    this.$toastr.w("You can't create a revision from an existing revision. Please use the original record instead.");
                    return;
                }
            }
            else if (actionObj.title === 'Duplicate') {
                const rowId = rowData.id; // id de la tabla costing
                this.cost_id = rowId;
                this.is_view = false;
                this.is_edit = false;
                this.is_revision = false;
                this.is_duplicated = true;
                console.log(this.is_duplicated);
                
                if (rowData.cost_type === 'ocean') {
                    this.addOceanCost = true;
                }else if(rowData.cost_type === 'truck'){
                    this.addTruckingCost = true;
                }
            }
            else if(actionObj.title === 'Print') {
                const rowId = rowData.id; // id de la tabla costing
                window.open(
				`${base_url}/costing/print/${rowId}`,
				"_blank"
			);
            }
        },  

        async openModalAddOcean(){
            this.addOceanCost = false;  
            this.modalKey++;
            this.cost_id = null;
            this.is_view = false;
            this.is_edit = false;
            this.is_revision = false;
            this.is_duplicated = false;

            await this.$nextTick();
            this. addOceanCost = true; 
            this.list = false;
        },

        async openModalAddTrucking(){
            this.addTruckingCost = false;  
            this.modalKey++;
            this.cost_id = null;
            this.is_view = false;
            this.is_edit = false;
            this.is_revision = false;
            this.is_duplicated = false;

            await this.$nextTick();
            this. addTruckingCost = true; 
            this.list = false;
        },

        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },

        cancelled() {
            this.deleteConfirmationModalActive = false;
        },

        async confirmed() {
            const id = this.rowData.id;
            const res = await delete_cost(id);
            $("#demo-delete").modal('hide');
            this.cancelled();
            if (res.data.message === 'Cost successfully removed') {
                this.$hub.$emit('reload-' + this.tableId);
                this.$toastr.s(res.data.message);
                return;
            }
            this.$toastr.w(res.data.message);
        },

        openEditModal() {
            this.editDetail = true;
        },

        async handleSave(inputs) {
      		this.preloader = true;
			try {
				const formData = new FormData();
				formData.append("data", JSON.stringify(inputs));
				const response = await axios.post(
					"/costingResources",
					formData,
				);
				this.$toastr.s(response.data.message);
                this.$hub.$emit('reload-' + this.tableId)
			} catch (error) {
				let msg = "Error saving data";
				if (error.response.data?.error) {
				    msg = error.response.data.error;
				}
				console.log(msg, error);
				this.$toastr.e(msg);
			}
			this.preloader = false;
            this.addOceanCost = false;
            this.addTruckingCost = false;
            this.is_revision = false;
            this.is_duplicated = false;
		},

        async handleSaveRevision(inputs){
            this.preloader = true;
			try {
				const formData = new FormData();
				formData.append("data", JSON.stringify(inputs));
				const response = await axios.post(
					"/costing/save_revision",
					formData,
				);
                console.log({response});
				this.$toastr.s(response.data.message);
                this.$hub.$emit('reload-' + this.tableId)
			} catch (error) {
				let msg = "Error saving data";
				if (error.response.data?.error) {
				    msg = error.response.data.error;
				}
				console.log(msg, error);
				this.$toastr.e(msg);
			}
			this.preloader = false;
            this.addOceanCost = false;
            this.addTruckingCost = false;
            this.is_revision = false;
            this.is_duplicated = false;
        },

        async handelUpdate(inputs) {
            const response = await update_data(inputs);
            const message = response.data.message;
            const status = response.data.status;
            if (status) {
               this.$toastr.s(message); 
            }

            this.$hub.$emit('reload-' + this.tableId);
            this.preloader = false;
            this.addOceanCost = false;
            this.addTruckingCost = false;
            
        }
    },
    mounted(){
        this.is_view = false;
        this.is_edit = false;
        this.is_revision = false;
        this.is_duplicated = false;
    }
}
    
</script>

